module.exports = __webpack_public_path__ + "static/media/workingmemory-words-12.87684527.mp3";